<div class="service-summary" [class.service-summary--force-column]="forceTrafficBottom()">
  <div class="service-summary__main">
    <div class="service-summary__header">
      <service-title-block
        [healthStatus]="health().status"
        [isAccessible]="isAccessible()"
        [service]="service()"
        [tags]="tags()"
        [title]="title()"
      />
    </div>
    <div class="service-summary__table">
      <div class="service-summary__table-row">
        <div class="service-summary__table-col">{{ "ServiceElement.Owner" | translate }}</div>
        <div class="service-summary__table-col">{{ organisationName() }}</div>
      </div>
      <div class="service-summary__table-row">
        <div class="service-summary__table-col">
          <span>{{ "ServiceElement.PortID" | translate }}</span>
        </div>
        <div class="service-summary__table-col">{{ subscriptionId() | shorten_guid }}</div>
      </div>
      @if (showVlanranges()) {
        <div class="service-summary__table-row">
          <div class="service-summary__table-col">{{ "ServiceElement.VLANID" | translate }}</div>
          <div class="service-summary__table-col">
            @for (row of vlanrangeRows(); track row.vlanrange) {
              <div>
                @if (row.untagged) {
                  <span>{{ "Subscription.UntaggedPort" | translate }}</span>
                } @else {
                  <span>{{ row.vlanrange }}</span>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (locations().length > 0) {
        <div class="service-summary__table-row">
          <div class="service-summary__table-col">
            {{ (locations().length === 1 ? "ServiceElement.Location" : "ServiceElement.Locations") | translate }}
          </div>
          <div class="service-summary__table-col service-summary__table-col--flex-newline">
            @for (location of locations(); track location) {
              <span>{{ location }}</span>
            }
          </div>
        </div>
      }

      <port-visualiser [available]="isAccessible()" [subscription]="service()" (selected)="navigateToService($event)" />

      <div class="service-summary__bottom">
        <div class="button button--secondary service-summary__scroll-button" (click)="navigateToChart()">
          {{ "Global.ShowTraffic" | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
